export default {"src":"/_next/static/media/icon-waiting-btn-shine.31aaac06.svg","height":73,"width":81,"blurWidth":0,"blurHeight":0};